<template>
  <span class="input-toggle">
    <input
      type="hidden"
      :name="name"
      :form="form"
      value="false"
    >
    <input
      :id="id"
      type="checkbox"
      :form="form"
      :name="name"
      :checked="_checked"
      :disabled="disabled"
      :required="required"
      value="true"
      @input="handleInput"
    >
  </span>
</template>

<script setup lang="ts">
const props = defineProps<{
  checked?: boolean
  disabled?: boolean
  form?: string
  id?: string
  name?: string
  required?: boolean
}>()

const _checked = defineModel<boolean>()

if (props.checked) {
  _checked.value = props.checked
}

const emit = defineEmits(['input'])
function handleInput(event: Event) {
  _checked.value = (event.target as HTMLInputElement).checked
  emit('input', (event))
}
</script>

<style>
@import url("~layers/app/components/Input/Toggle.css");
</style>
